import { ButtonHeading } from "components";
import BootstrapTable from "components/BootstrapTable";
import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { IoChevronBack, IoChevronForward } from "react-icons/io5";
import moment from "moment";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { BsThreeDotsVertical } from "react-icons/bs";
import useDocumentTitle from "hooks/useDocumentTitle";
import { getLeaderboardData } from "_services";
import { Images } from "constants";
import { constant } from "constants";
import Tab from "components/common/Tab/Tab";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

const Leaderboard = () => {
  useDocumentTitle("User | MySifarish");
  const getUserData = JSON.parse(localStorage.getItem("userData"));
  const navigate = useNavigate();
  const location = useLocation();
  const [userListData, setUserListData] = useState([]);
  const [weeklyDataList, setWeeklyDataList] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const itemsPerPage = 20;
  const [loading, setLoading] = useState(false);
  const [activeTab, setActiveTab] = useState(1);

  // const [selectedRange, setSelectedRange] = useState({
  //   startDate: moment().startOf("month"),
  //   endDate: moment().endOf("month"),
  // });

  const [filter, setFilter] = useState({
    userId: "",
    page: 1,
    limit: 15,
    // startDate: null,
    // endDate: null,
    isActive: "",
    type: "",
    userIdToFetch: "",
  });

  useEffect(() => {
    const id = location?.state?._id;

    if (id) {
      fetchSifarishPoints(id);
    } else {
      fetchSifarishPoints();
    }
  }, [filter]);

  const fetchSifarishPoints = async (data) => {
    setLoading(true);
    try {
      const payload = {
        ...filter,
        // startDate: moment(selectedRange.startDate).format("YYYY-MM-DD"),
        // endDate: moment(selectedRange.endDate).format("YYYY-MM-DD"),
        isActive: filter?.isActive,
        userIdToFetch: data
          ? data
          : filter?.userIdToFetch
          ? filter?.userIdToFetch
          : "",
        userId: getUserData._id,
      };
      const res = await getLeaderboardData(payload);
      if (res) {
        setUserListData(res?.data?.leaderboard);
        setWeeklyDataList(res?.data?.weeklyLeaderboard);
        setTotalCount(res?.data?.totalRecords);
        setLoading(false);
      } else {
        toast.error(res?.responseMessage);
        setLoading(false);
      }
    } catch (error) {
      toast.error(error?.message || "Something went wrong");
      setLoading(false);
    }
  };

  const columns = [
    { header: "", accessor: "serial" },
    { header: "User Name", accessor: "user_name" },
    { header: "Sifarish Points", accessor: "sifarishPoints" },
    { header: "Rank", accessor: "type" },
  ];

  const rowListData = (data) =>
    data?.map((item, i) => ({
      ...item,
      serial: (
        <div className="signDropdown">
          {/* <button className="dropbtn11">
            <BsThreeDotsVertical />
          </button> */}
          <div className="dropdownContent"></div>
        </div>
      ),
      sifarishPoints: item?.sifarishPoints || "-",
      type: item?.rank || "-",
      user_name: (
        <>
          <Link to={`/user/details/${item?.userId}`} className="__userPro">
            <img
              src={item?.userProfileImageUrl || Images.USERLIMG}
              alt="user Img"
              style={{ borderRadius: "50%" }}
              width={30}
              height={30}
            />
            <span>{item?.userId && `${item?.fullName} `}</span>
          </Link>
        </>
      ),
    }));

  // const handleApply = (newRange) => {
  //   setSelectedRange(newRange);
  //   setFilter((s) => ({
  //     ...s,
  //     page: 1,
  //     startDate: newRange.startDate,
  //     endDate: newRange.endDate,
  //   }));
  // };

  const handleRemoveTitle = () => {
    navigate(location.pathname, { replace: true });
    fetchSifarishPoints();
  };

  const tabProps = {
    tabList: constant.leaderboardTab,
    callBackTab: (e) => setActiveTab(e),
    activeTab: activeTab,
  };

  const handlePageChange = (page) => {
    setFilter((s) => ({ ...s, page }));
  };

  const renderPagination = () => {
    const totalPages = Math.ceil(totalCount / itemsPerPage);
    const currentPage = filter.page;
    let pages = [];

    const createPageItem = (i) => (
      <li key={i} className={`page-item ${i === currentPage ? "active" : ""}`}>
        <a className="page-link _avPointer" onClick={() => handlePageChange(i)}>
          {i}
        </a>
      </li>
    );

    const rangeStart = Math.max(2, currentPage - 2);
    const rangeEnd = Math.min(totalPages - 1, currentPage + 2);

    pages.push(createPageItem(1));

    if (rangeStart > 2) {
      pages.push(
        <li key="dots-before" className="page-item disabled">
          <span className="page-link">...</span>
        </li>
      );
    }

    for (let i = rangeStart; i <= rangeEnd; i++) {
      pages.push(createPageItem(i));
    }

    if (rangeEnd < totalPages - 1) {
      pages.push(
        <li key="dots-after" className="page-item disabled">
          <span className="page-link">...</span>
        </li>
      );
    }

    if (totalPages > 1) {
      pages.push(createPageItem(totalPages));
    }

    return (
      <ul className="pagination">
        <li className={`page-item ${filter.page === 1 ? "disabled" : ""}`}>
          <a
            className="page-link _avPointer"
            onClick={() => handlePageChange(filter.page - 1)}
          >
            <IoChevronBack />
          </a>
        </li>
        {pages}
        <li
          className={`page-item ${
            filter.page === totalPages ? "disabled" : ""
          }`}
        >
          <a
            className="page-link _avPointer"
            onClick={() => handlePageChange(filter.page + 1)}
          >
            <IoChevronForward />
          </a>
        </li>
      </ul>
    );
  };

  const exportToCSV = async () => {
    try {
      const payload = {
        ...filter,
        isActive: filter?.isActive,
        userIdToFetch: filter?.userIdToFetch ? filter?.userIdToFetch : "",
        userId: getUserData._id,
        limit: 15,
      };

      const res = await getLeaderboardData(payload);

      const leaderboardData = res.data?.leaderboard || [];
      const weeklyLeaderboardData = res.data?.weeklyLeaderboard || [];

      if (
        (!leaderboardData || leaderboardData.length === 0) &&
        (!weeklyLeaderboardData || weeklyLeaderboardData.length === 0)
      ) {
        toast.error("No data to export!");
        return;
      }

      const wb = XLSX.utils.book_new();

      const columnWidths = [
        { wch: 10 },
        { wch: 35 },
        { wch: 20 },
        { wch: 10 },
      ];

      if (leaderboardData.length > 0) {
        const formattedLeaderboard = leaderboardData.map((user, index) => ({
          "Serial No": index + 1,
          "User Name": user?.fullName || "-",
          "Sifarish Points": user?.sifarishPoints || "-",
          Rank: user?.rank || "-",
        }));

        const ws1 = XLSX.utils.json_to_sheet(formattedLeaderboard);
        ws1["!cols"] = columnWidths;
        XLSX.utils.book_append_sheet(wb, ws1, "Leaderboard");
      }

      if (weeklyLeaderboardData.length > 0) {
        const formattedWeekly = weeklyLeaderboardData.map((user, index) => ({
          "Serial No": index + 1,
          "User Name": user?.fullName || "-",
          "Sifarish Points": user?.sifarishPoints || "-",
          Rank: user?.rank || "-",
        }));

        const ws2 = XLSX.utils.json_to_sheet(formattedWeekly);
        ws2["!cols"] = columnWidths;
        XLSX.utils.book_append_sheet(wb, ws2, "Weekly Leaderboard");
      }

      const wbout = XLSX.write(wb, { bookType: "xlsx", type: "array" });
      const blob = new Blob([wbout], {
        type: "application/octet-stream",
      });
      const epochTime = Date.now();
      saveAs(blob,`Leaderboard_Report_${epochTime}.xlsx`);

      toast.success("Leaderboard exported successfully!");
    } catch (error) {
      console.error(error);
      toast.error(error?.message || "Something went wrong during export.");
    }
  };

  return (
    <>
      <ButtonHeading
        title={`Leaderboard`}
        handleRemoveTitle={() => handleRemoveTitle()}
        showCross={location?.state?._id ? true : false}
        // showDateRange={true}
        // selectedRange={selectedRange}
        filter={filter}
        setFilter={setFilter}
        Export={true}
        ExportSubmit={exportToCSV}
        // handleApply={handleApply}
      />
      <div className="addPr_flBx">
        <Tab {...tabProps} />
      </div>

      <div className="_tabWith_outTab __trxNew_tab">
        <BootstrapTable
          columns={columns}
          data={rowListData(
            activeTab === 1
              ? userListData
              : activeTab === 2
              ? weeklyDataList
              : []
          )}
          isLoading={loading}
          colSpan={3}
        />
        <div className="paginationFt_avt">{renderPagination()}</div>
      </div>
    </>
  );
};

export default Leaderboard;
